/**
 * PATH: packages/job-hub/src/jobs/qa/qaInspectionStatusLabel.ts
 * FILE_ID: JOBHUB-QA-INSPECTION-STATUS-LABEL-001
 * PURPOSE: One visibility sentence for a QA list status chip.
 * WHY: The long visibility sentence squeezed the QA name and was not true.
 */
const VISIBILITY: Record<string, string> = {
  draft: 'Draft',
  published: 'Published',
}

export function qaInspectionStatusLabel(status: string | null | undefined): string {
  const raw = (status ?? '').trim()
  if (!raw) return ''
  return VISIBILITY[raw] ?? raw.replace(/_/g, ' ')
}
